import { Translation } from 'cng-common/features/translations'
import { Nullable } from 'cng-common/models/utils'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { URL_PROFILING_TICKETS } from 'src/config/url'

import { contactRelinkingValidationMessageTranslations } from './translation'

import styles from './ContactRelinkingValidationMessageContent.module.scss'

type Props = {
  text: Nullable<string>
  onCancel: () => void
}

export const ContactRelinkingValidationMessageContent = ({ text, onCancel }: Props) => {
  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <h5>
          <Translation
            text={contactRelinkingValidationMessageTranslations.criticalRelinkingMessage.header}
            span
            htmlAvailable
          />
        </h5>
        <p>
          <Translation text={text || ''} span htmlAvailable />
        </p>
        <a
          href={URL_PROFILING_TICKETS}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.bold}
        >
          <Translation
            text={
              contactRelinkingValidationMessageTranslations.criticalRelinkingMessage
                .useProfilingTicket
            }
            span
            htmlAvailable
          />
        </a>
        <Flex justifyContent={'flex-end'} className={styles.buttons}>
          <Button onClick={onCancel}>
            <Translation
              text={contactRelinkingValidationMessageTranslations.criticalRelinkingMessage.cancel}
              span
            />
          </Button>
        </Flex>
      </div>
    </div>
  )
}
